import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Confirm from 'components/Confirm';
import { Form, Input, ButtonGroup } from 'components/HookForm';
import Message from 'components/Message';
import { notListedPlatformModalMessages as messages } from '../../CalendarLinks.messages';

const NotListedPlatformModal = ({ handleOnCancel, handleOnSubmit }) => (
  <Confirm title={<Message message={messages.title} />}>
    {({ title, bodyClass }) => (
      <Form onSubmit={handleOnSubmit}>
        <>
          {title}
          <div className={bodyClass}>
            <Input name="platformName" label={messages.platformNameLabel} />
          </div>

          <ButtonGroup>
            <Message as={Button} styled="tertiary" message={messages.cancel} onClick={handleOnCancel} />
            <Message as={Button} styled="primary" type={Button.TYPES.SUBMIT} message={messages.submit} />
          </ButtonGroup>
        </>
      </Form>
    )}
  </Confirm>
);

NotListedPlatformModal.propTypes = {
  handleOnCancel: PropTypes.func,
  handleOnSubmit: PropTypes.func,
};

export default NotListedPlatformModal;
